import { ValueObject } from '../shared/ValueObject';
import type { MaintenanceDisplayItem } from '@/features/panels/constants/panelDetailTab.constants';

// ========== 型定義 ==========

interface OperationCountValueProps {
  readonly displayName: string;
  readonly count: number | null;
  readonly unit: string;
}

// ========== 値オブジェクト ==========

/**
 * メンテナンス動作回数の値オブジェクト
 *
 * 動作回数の表示名・カウント値・単位を不変に保持する。
 * 生成時に完全な状態であり、変更は新インスタンス生成で対応。
 */
export class OperationCountValue extends ValueObject<OperationCountValueProps> {
  private constructor(props: OperationCountValueProps) {
    super(props);
  }

  /**
   * OperationCountValueを生成
   */
  public static create(props: OperationCountValueProps): OperationCountValue {
    return new OperationCountValue({
      displayName: props.displayName,
      count: props.count,
      unit: props.unit,
    });
  }

  public getDisplayName(): string {
    return this.value.displayName;
  }

  public getCount(): number | null {
    return this.value.count;
  }

  public getUnit(): string {
    return this.value.unit;
  }

  /**
   * プレゼンテーションモデルに変換
   */
  public toPresentationModel(): MaintenanceDisplayItem {
    return {
      name: this.value.displayName,
      value: this.value.count,
      unit: this.value.unit,
    };
  }
}
